import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { fetchMorningstarToken } from "./useMorningstarToken";

/**
 * Prefetches the Morningstar API token at app startup so it's ready when
 * exposure data is needed. Non-blocking: runs in useEffect, does not await.
 */
export const MorningstarTokenPrefetcher = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    queryClient.prefetchQuery({
      queryKey: ["morningstar", "token"],
      queryFn: fetchMorningstarToken,
      staleTime: 23 * 60 * 60 * 1000, // 23 hours (match useMorningstarToken)
    });
  }, [queryClient]);

  return null;
};
